import {ServiceLine as ServiceLineSynthesisCore} from 'quote-export-manager-core';
import {Injectable} from '@angular/core';
import {ServiceLine} from '../../../core/models/quote/service-line';
import {QuoteServiceV1Mapper} from './quote-service-v1.mapper';

@Injectable()
export class ServiceLineV1Mapper {
    constructor(
        private readonly quoteServiceV1Mapper: QuoteServiceV1Mapper,
    ) {
    }

    toServiceLine(serviceLine: ServiceLine): ServiceLineSynthesisCore {
        return new ServiceLineSynthesisCore(
            serviceLine.code,
            this.quoteServiceV1Mapper.toQuoteService(serviceLine.newQuoteService),
            this.quoteServiceV1Mapper.toQuoteService(serviceLine.existingQuoteService),
            this.quoteServiceV1Mapper.toQuoteService(serviceLine.renewalQuoteService),
            serviceLine.appliedPrice,
            serviceLine.appliedPriceColor,
            serviceLine.monthlyAmount,
            serviceLine.weeklyAmount,
            serviceLine.synthesisViews,
            serviceLine.billingLines
        );
    }
}
